import React from "react";
import { Nav, Button } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ThemeToggle from "../ThemeToggle";

const NAV_ITEMS = [
  {
    path: "/staff",
    label: "Tổng quan",
    sublabel: "Dashboard",
    icon: "bi-grid-fill",
  },
  {
    path: "/staff/tables",
    label: "Quản lý Bàn",
    sublabel: "Tables",
    icon: "bi-diagram-3-fill",
  },
  {
    path: "/staff/orders",
    label: "Đơn món",
    sublabel: "Orders",
    icon: "bi-card-checklist",
  },
  {
    path: "/staff/devices",
    label: "Thiết bị",
    sublabel: "Devices",
    icon: "bi-headphones",
  },
  {
    path: "/staff/feedback",
    label: "Hỗ trợ",
    sublabel: "Support",
    icon: "bi-chat-dots-fill",
  },
];

function StaffSidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("userRole");
    localStorage.removeItem("userEmail");
    navigate("/login");
  };

  return (
    <div className="d-flex flex-column flex-shrink-0 staff-sidebar">
      <div className="staff-sidebar__brand">
        <i className="bi bi-cup-hot-fill"></i>
        <span>UC COFFEE</span>
      </div>

      <Nav defaultActiveKey="/staff" className="flex-column mb-auto mt-3">
        {NAV_ITEMS.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Nav.Item key={item.path}>
              <Nav.Link
                as={Link}
                to={item.path}
                className={`staff-nav-link ${isActive ? "active" : ""}`}
              >
                <i className={`bi ${item.icon}`}></i>
                <div className="flex-grow-1">
                  <div style={{ fontWeight: 600, fontSize: "0.95rem" }}>
                    {item.label}
                  </div>
                  <small
                    style={{
                      opacity: 0.7,
                      fontSize: "0.75rem",
                      color: "var(--text-dim)",
                    }}
                  >
                    {item.sublabel}
                  </small>
                </div>
              </Nav.Link>
            </Nav.Item>
          );
        })}
      </Nav>

      <div className="staff-user-card">
        <div className="mb-3 d-flex justify-content-center">
          <ThemeToggle />
        </div>
        <div className="d-flex align-items-center mb-3">
          <div
            style={{
              width: "48px",
              height: "48px",
              borderRadius: "50%",
              background:
                "linear-gradient(135deg, var(--amber-500) 0%, var(--amber-600) 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "1.25rem",
              fontWeight: 700,
              color: "var(--bg-primary)",
              marginRight: "0.75rem",
              boxShadow: "0 0 20px var(--glow-amber)",
            }}
          >
            SM
          </div>
          <div className="flex-grow-1">
            <div className="fw-bold" style={{ fontSize: "0.95rem" }}>
              Staff Member
            </div>
            <small style={{ color: "var(--text-muted)", fontSize: "0.8rem" }}>
              Ca sáng · Online
              <span
                className="pulse-indicator ms-2"
                style={{
                  background: "var(--success)",
                  width: "8px",
                  height: "8px",
                  display: "inline-block",
                }}
              ></span>
            </small>
          </div>
        </div>
        <Button
          size="sm"
          className="w-100 rounded-3 staff-logout-btn"
          onClick={handleLogout}
        >
          <i className="bi bi-box-arrow-right me-2"></i>
          Đăng xuất
        </Button>
      </div>
    </div>
  );
}

export default StaffSidebar;
